// extracted by mini-css-extract-plugin
export var childrenContainer = "_5g-0";
export var virtualScrollArea = "_5g-1";